import { GameObj, KAPLAYCtx } from "kaplay"
import colors from "./colors"
import { playerSprite } from "./player-scene"
import { setDefaultAutoSelectFamilyAttemptTimeout } from "net"
import { creditScene } from "./credit-scene"

export function gameScene(k: KAPLAYCtx) {
  k.loadMusic("level1", "bgm/level-1/level-1.mp3")
  k.loadMusic("level2", "bgm/level-2/level-2.mp3")
  k.loadMusic("level3", "bgm/level-3/level-3.mp3")
  k.play("level1", { volume: 0.01})
  creditScene(k)
  k.loadSprite("bg", "background/backgroundextend.png");
  k.scene("game-scene", () => {
    k.add([
      k.sprite("bg"),
      // k.pos(-20, -650),
      k.pos(-20, -1350),
      k.scale(0.27)
    ])
    // k.add([
    //   k.rect(k.width(), k.height()),
    //   k.pos(-20),
    //   k.color(colors[7])
    // ])
    // red
    // k.add([
    //   k.rect(800, 900),
    //   k.pos(-80, -700),
    //   k.color(colors[8]),
    //   k.z(-900)
    // ])
    // red
    // k.add([
    //   k.rect(800, 900),
    //   k.pos(-80, -1600),
    //   k.color(colors[11]),
    //   k.z(-900)
    // ])


    k.loadSprite("spritesheet", "./maps/topdownasset.png", {
      sliceX: 39,
      sliceY: 31,
    })

    k.loadSprite("map", "./maps/map.png");

    let children: GameObj
    async function main() {
      const mapData = await (await fetch("./maps/map.json")).json();
      // const map = k.add([k.pos(100, 100)]);
      const map = k.add([k.pos(0, -1400)]);
      // k.setCamPos(240, 380); // 240 140
      k.setCamPos(240, 380); // 240 140
      // k.setCamScale(1);
      k.setCamScale(4);

      map.add([k.sprite("map")]);

      for (const layer of mapData.layers) {
        if (layer.type === "tilelayer") continue;

        if (layer.name === "Colliders") {
          for (const object of layer.objects) {
            map.add([
              k.area({ shape: new k.Rect(k.vec2(0), object.width, object.height)   }),
              k.body({ isStatic: true }),
              k.pos(object.x, object.y),
              "platform"
            ]);
          }
        }

        if (layer.name === "WallColliders") {
          for (const object of layer.objects) {
            map.add([
              k.area({ shape: new k.Rect(k.vec2(0), object.width, object.height)   }),
              k.body({ isStatic: true }),
              k.pos(object.x, object.y),
              "wall-colliders"
            ]);
          }
        }

        if (layer.name === "GroundCollider") {
          for (const object of layer.objects) {
            map.add([
              k.area({ shape: new k.Rect(k.vec2(0), object.width, object.height)   }),
              k.body({ isStatic: true }),
              k.pos(object.x, object.y),
              "ground-collider"
            ]);
          }
        }
      }
    }

    k.loadSound("crash-bubble", "./sfx/crash-bubble.mp3");
    k.loadSound("spawn-bubble", "./sfx/spawn-bubble.mp3");
    k.loadSound("jump", "./sfx/jump.wav");


    k.onLoad(() => {
      k.onKeyPress("f", () => {
        spawnBubble(children.pos.x + 30, children.pos.y, colors[8]);
      })

      k.onButtonDown("downButton", () => {
        playerAnimatedSprite.pos.y += 40 * k.dt()
      })
      k.onButtonDown("upButton", () => {
        playerAnimatedSprite.pos.y -= 40 * k.dt()
      })
      k.onButtonDown("leftButton", () => {
        playerAnimatedSprite.pos.x -= 80 * k.dt()
        playerWalk.flipX = false

        chargeBar.pos.x = playerAnimatedSprite.pos.x - 10
        chargeBar.pos.y = playerAnimatedSprite.pos.y + 60
      })
      k.onButtonDown("rightButton", () => {
        playerAnimatedSprite.pos.x += 80 * k.dt()
        playerWalk.flipX = true

        // BUG: finally found the bug
        // playerAnimatedSprite.use(playerWalk)
        if (currentSprite !== "walk") {
          playerAnimatedSprite.unuse("sprite")
          playerAnimatedSprite.use(playerWalk)
          playerAnimatedSprite.play("animate")
          currentSprite = "walk"
        }

        chargeBar.pos.x = playerAnimatedSprite.pos.x - 10
        chargeBar.pos.y = playerAnimatedSprite.pos.y + 60
      })


      // mecha: jump
      let charge = 0; //current jump charge count
      const maxCharge = 1000;
      const chargeRate = 1000;
      const minJumpForce = 300;
      let isCharging = false;
      k.setGravity(1000);

      const chargeBar =  k.add([
        k.rect(5,10),
        // k.pos(player.pos.x - 60, player.pos.y + 100),
        // k.pos(player.pos.x - 2, player.pos.y + 50),
        k.pos(playerAnimatedSprite.pos.x - 10, playerAnimatedSprite.pos.y + 270),
        k.color(colors[9]),
        k.anchor("bot")
      ])

      let jumpSfx;
      k.onButtonDown("aButton", () => {
        if(!isCharging && playerAnimatedSprite.isGrounded()) {
          isCharging = true;
          charge = 0;
          // k.play("jump")
          if (currentSprite !== "walk") {
          playerAnimatedSprite.unuse("sprite")
          playerAnimatedSprite.use(playerWalk)
          playerAnimatedSprite.play("animate")
          currentSprite = "walk"
        }

        }
      })

      var yCameraOutside = 
      playerAnimatedSprite.onUpdate(() => {
        // Move camera up as the player ascends
        if (playerAnimatedSprite.pos.y < k.height() / 2) {
          // const cameraOffset = k.height() / 2 - playerAnimatedSprite.pos.y;
          const cameraOffset = 40
          // k.setCamPos(0, k.getCamPos().y - cameraOffset);
          // k.setCamPos(240, k.getCamPos().y - cameraOffset);
          // k.setCamPos(240, 200 - 0.09);

          // 
          // k.setCamPos(240, k.getCamPos().y - 0.35);
          k.setCamPos(240, k.getCamPos().y - 0.35);

          // 240 140          console.log(k.getCamPos()) 
          // 350          console.log(cameraOffset)


          // Move all platforms down to simulate scrolling
          // k.every("platform", (platform) => {
          //     platform.pos.y += cameraOffset;
          //     // Destroy platforms that go off-screen
          //     if (platform.pos.y > height()) {
          //         destroy(platform);
          //     }
          // });

          // Generate new platforms as the player ascends
          // while (k.get("platform").length < 5) {
          //     createPlatform(rand(0, width() - PLATFORM_WIDTH), rand(-100, 0));
          // }
        }

        // charing when jump
        if(isCharging) {
          charge += chargeRate * k.dt();
          if (charge > maxCharge) charge = maxCharge;
          chargeBar.height = (charge/maxCharge) * 200;
          // k.debug.log("Charge: "+ Math.floor(charge));
        }else{
          chargeBar.height = 0;
        }
      })

      k.onButtonRelease("aButton", () => {
        if(isCharging) {
          jumpSfx = k.play("jump", { speed: 0.5, volume: 3 });  // Start the sound and loop it
          const jumpForce = Math.max(minJumpForce, charge);
          playerAnimatedSprite.jump(jumpForce)
          // k.get("player")[0].jump(jumpForce);
          if(jumpForce==minJumpForce){
            k.shake(0.5)
          }if (jumpForce==maxCharge) {
            k.shake(5)
          } else {
            k.shake(3)
          }
          isCharging = false;
          charge = 0;
        }
      })
    });
    main()

    k.loadSprite("bubble", "character/bubble/bubble.png", {
      sliceX: 4,
      sliceY: 1,
      anims: {
        animate: { from: 0, to: 3, loop: false },
      },
    })

    let activeBubbles = 0
    k.loop(5, () => {
      spawnBubble(children.pos.x + 30, children.pos.y, colors[8]);
    })

    let mybubble: GameObj
    function spawnBubble(x, y, color) {
      if (activeBubbles >= 1) {
        console.log("Maximum number of bubbles reached");
        return; // Do not spawn a new bubble if the limit is reached
      }

      k.play("spawn-bubble")

      let vecDirection = 10

      if (children.pos.x > 150) {
        vecDirection *= -1
      } else {
        vecDirection *= 1
      }

      let ballonOffscreen = false
      mybubble = k.add([
        k.sprite("bubble", {
          // anim: "animate",
          animSpeed: 1,
        }),
        k.pos(x + 20, y + 40),
        k.area({
          collisionIgnore: ["platform"],
        }),
        k.body({
          gravityScale: 0
        }),
        k.rotate(0),
        // k.circle(15),
        k.color(colors[12]),
        k.scale(0.2),
        // k.scale(0.05),  // Start small
        k.offscreen({destroy: true}),
        k.anchor("center"),
        "bubble",
        {
          // vel: k.vec2(80, 30),  // Initial velocity (moving right)
          acc: 10,             // Acceleration (for upward movement)
        }
      ]);
      mybubble.vel = k.vec2(vecDirection, 30)  // Initial velocity (moving right)


      mybubble.onCollide("wall-colliders", () => {
      })

      let gameLoseBecauseOffscreenBubble = false

      if (gameLoseBecauseOffscreenBubble) {
        // TODO: game end scene goes here
        k.go("credit-scene")
      }

      mybubble.onUpdate(() => {
        if (children.pos.y - mybubble.pos.y > 250) {
          gameLoseBecauseOffscreenBubble = true
        // TODO: game end scene goes here
          k.wait(0, () => k.go("credit-scene")); // Prevent freezing
        }
        // if (mybubble.pos.y < 0) {
        //   alert("gameover")
        //   k.go("game-scene")
        // }
        // k.debug.log(mybubble.vel)
        const maxSpeed = -15; // Set your speed limit
        const speed = mybubble.vel.y; // Get current speed

        if (speed < maxSpeed) {
          mybubble.vel.y = maxSpeed
          // mybubble.vel = mybubble.vel.unit().scale(maxSpeed); // Scale velocity to max speed
        }
      })


      activeBubbles++

      mybubble.onUpdate(() => {
        // console.log(mybubble.pos.y)
      })

      mybubble.onCollide("platform", () => {
        alert("hello")
      })

      spawnParticles(x, y, color);
    }


    function spawnParticles(x, y, color) {
      let angle = Math.random() * Math.PI * 2;  // Random direction
      for (let i = 0; i < 5; i++) {  // Spawn 5 mini bubbles
        // let speed = Math.random() * 30 + 10;  // Random speed
        let speed = Math.random() * 30 + 10;  // Random speed

        let particle = k.add([
          k.sprite("bubble", {
            // anim: "animate",
            animSpeed: 1,
          }),
          k.scale(0.05),
          k.area(),
          // k.body(),
          k.rotate(0),
          // k.circle(15),
          k.pos(x, y),
          k.color(colors[12]),
          "particle",
          {
            vel: k.vec2(Math.cos(angle) * speed, Math.sin(angle) * speed),
            life: 1.5,  // Fade-out duration
          }
        ]);
      }
    }

    const playerAnimatedSprite = playerSprite(k)
    let [playerIdle, playerWalk, playerJump] = ["idle", "walk", "jump"].map(name => k.sprite(name, { frame: 1, flipX: false, flipY: false, animSpeed: 0.4 }));

    // playerAnimatedSprite.use(playerJump)
    // playerAnimatedSprite.play("animate")

    let currentSprite = "jump" // Track current sprite

    // children
    const SPEED = 100; // Adjust speed as needed
    const directions = [
      k.vec2(1, 0),  // Right
      k.vec2(-1, 0), // Left
      k.vec2(0, 1),  // Down
      k.vec2(0, -1), // Up
    ];


    let currentDirection = k.vec2(0, 0);

    function changeDirection() {
      currentDirection = directions[Math.floor(Math.random() * directions.length)];
    }
    k.loop(1.5, changeDirection);

  k.loadSprite("children", "sprites/children.png", {
    sliceX: 1,
    sliceY: 4,
    anims: {
      animate: { from: 0, to: 3, loop: true },
    },
  })

    children = k.add([
      // k.sprite("spritesheet", { frame: 936 }), // idle frame of the player sprite
    k.sprite("children", {
      frame: 1,
      flipX: false,
      flipY: false,
      // animSpeed: 0.8 
      animSpeed: 0.4,
      anim: "animate",
    }),
      k.pos(100, 250),
      k.area({
          collisionIgnore: ["platform"],
      }),
      k.body(),
      k.scale(0.2),
      k.z(30),
      "children",
    ]);

    k.onUpdate("children", (obj) => {
      obj.move(currentDirection.scale(SPEED));
    });

    // Centralized update function for all bubbles
    k.onUpdate("bubble", (bubble) => {
      // Apply acceleration (parabolic motion)
      bubble.vel.y -= bubble.acc * k.dt();

      // Update position
      bubble.pos.x += bubble.vel.x * k.dt();
      bubble.pos.y += bubble.vel.y * k.dt();

      // Smoothly rotate the bubble using lerp

      const targetAngle = bubble.angle + bubble.rotationSpeed * k.dt(); // Target rotation angle
      bubble.angle = k.lerp(bubble.angle, targetAngle, 0.1); // Use a value between 0 and 1 (e.g., 0.1 for smooth rotation)

      // Destroy bubble if it goes off-screen
      // if (bubble.pos.y < 0) {
      //   bubble.destroy();
      //   activeBubbles--
      // }
    });

    // Centralized update function for all particles
    k.onUpdate("particle", (particle) => {
      particle.pos.x += particle.vel.x * k.dt();
      particle.pos.y += particle.vel.y * k.dt();
      particle.life -= k.dt();

      if (particle.life <= 0) {
        particle.destroy();
      }
    });

    playerAnimatedSprite.onCollide("bubble", (bubble) => {
      bubble.play("animate")
      k.play("crash-bubble", {
        volume: 7
      })
      k.wait(0.6, () => {
        bubble.destroy()
        activeBubbles--
      })
      // TODO: only explode when player higher than balloon
      // if (playerAnimatedSprite.y < bubble.x) {
      //   k.debug.log("touching")
      //   bubble.play("animate")
      // }
      // bubble.destroy()
    })

    // black
    let safetyPlatform = k.add([
      k.rect(740, 80),
      k.pos(-120, 514),
      k.color(colors[0]),
      k.opacity(0),
      k.z(100),
      k.area(),
      k.body({isStatic: true}),
      "safety-platform"
    ])


    safetyPlatform.onUpdate(() => {
      safetyPlatform.pos.y -= 21 * k.dt()
      // console.log(safetyPlatform.pos.y)

      // TODO: credit scene played after poped out 3 balloon
      // if (safetyPlatform.pos.y < -300) {
      //   creditScene(k)
      //   k.go("credit-scene")
      // }
    })

    const timerText = k.add([
      k.text("0"),
      k.pos(20, 20),
      k.layer("ui"),
      k.z(999)

    ]);

    k.onUpdate(() => {
      timerText.text = Math.floor(k.time()).toString(); // Update the time every frame
      // console.log(timerText.text)
      timerText.pos.y -= 20
    });



  })
}
